/**
 * roll
 */

import $ from 'jquery';
import 'slick-carousel';

import Page from 'js/lib/page';

export default class Roll extends Page {
  constructor(element) {
    super(element);
  }
  init() {
    this.elements({
      container: '.js-roll-container',
      prev: '.js-roll-prev',
      next: '.js-roll-next'
    });

    this.events({
      'init.roll': {
        target: this.$.container,
        handler: () => this.show()
      }
    });

    this.slick();
  }
  slick() {
    this.$.container.slick({
      dots: false,
      arrows: true,
      prevArrow: this.$.prev,
      nextArrow: this.$.next,
      speed: 500,
      cssEase: 'ease',
      slidesToShow: 4,
      swipeToSlide: true
    });
  }
  show() {
    const deferred = $.Deferred();
    this.$.root.addClass('is-inited');
    this.$.root.one('transitionend', () => deferred.resolve());

    return deferred.promise();
  }
}

Page.make(Roll, '.js-roll');
